class Product {
  constructor() {
    this.acc = [];
    this.container = document.querySelector(".m-main-product");
    MinimogTheme.CompareProduct && MinimogTheme.CompareProduct.setCompareButtonsState();
    MinimogTheme.Wishlist && MinimogTheme.Wishlist.setWishlistButtonsState();
    this.addRecentViewedProduct();

    addEventDelegate({
      context: this.container,
      selector: (window.__minimog_review_selector || '') + '.m-product-collapsible .jdgm-widget-actions-wrapper, .m-product-collapsible .spr-summary-actions-newreview',
      handler: (e) => {
      const index = e.target.closest('.m-product-collapsible').dataset.index
      setTimeout(() => {
        this.acc[Number(index)].setContentHeight()
      }, 300)},
      capture: true
    })
  }

  addRecentViewedProduct() {
    const cookies = getCookie('m-recent-viewed-products')
    let products = cookies ? JSON.parse(cookies) : []
    if (products.indexOf(MinimogSettings.productHandle) === -1) {
      products.unshift(MinimogSettings.productHandle)
      products = products.slice(0, 20)
      setCookie('m-recent-viewed-products', JSON.stringify(products));
    }
  }
}

// new Product();

document.addEventListener("DOMContentLoaded", function () {
    let firstBlock = document.querySelector(".main-product__block.main-product__block-collapsible_tab");

    if (firstBlock) {
        let paragraphs = firstBlock.querySelectorAll(".m-collapsible--content__inner p");

        let textsToHide = [
            "Click here for size guide.",
            "For further sizing assistance please contact us on info@ahluwalia.world",
            "UK Standard Shipping - £7.95.",
            "Rest of World Standard Shipping - £24.95.",
            "Please note that taxes and duties may apply to orders shipped outside the UK.",
            "Shipping & Returns"
        ];

        paragraphs.forEach(p => {
            let fullText = p.innerText.trim().replace(/\s+/g, " "); // Get full text, ignoring child elements
            if (textsToHide.some(text => fullText.includes(text))) {
                p.style.display = "none";
            }
        });
    }
});